/**
 * Shared Field Type System
 *
 * Single source of truth for field value types, field sources,
 * and badge color functions used by both Field Defs and Additional Fields.
 */

// Unified type covering all field value types
export type FieldValueType =
  | 'string' | 'number' | 'boolean'    // data types (shared)
  | 'json' | 'array'                    // data types (shared)
  | 'password' | 'url' | 'hostname'    // UI-hint types (Field Defs only)
  | 'email' | 'ip_address' | 'port'    // UI-hint types (Field Defs only)
  | 'select';                           // UI-hint type (Field Defs only)

export type FieldSource = 'device' | 'template' | 'user' | 'device_type' | 'hardware_field_def';

export function getTypeBadgeColor(type: string): string {
  switch (type) {
    case 'string':
      return '#6b7280';  // gray
    case 'number':
      return '#3b82f6';  // blue
    case 'boolean':
      return '#10b981';  // green
    case 'json':
      return '#f59e0b';  // amber
    case 'array':
      return '#8b5cf6';  // purple
    case 'password':
      return '#ef4444';  // red
    case 'url':
      return '#06b6d4';  // cyan
    case 'hostname':
      return '#8b5cf6';  // purple
    case 'port':
      return '#f97316';  // orange
    case 'select':
      return '#a855f7';  // violet
    case 'email':
      return '#06b6d4';  // cyan
    case 'ip_address':
      return '#f97316';  // orange
    default:
      return '#6b7280';  // gray
  }
}

export function getSourceBadgeColor(source: string): string {
  switch (source) {
    case 'device':
      return '#10b981';  // green
    case 'template':
      return '#3b82f6';  // blue
    case 'device_type':
      return '#6b7280';  // gray
    case 'user':
      return '#8b5cf6';  // purple
    case 'hardware_field_def':
      return '#d97706';  // amber
    default:
      return '#6b7280';  // gray
  }
}
